/* eslint-disable no-unused-vars */
// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MuiLink from "@mui/material/Link";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKBadge from "components/MKBadge";

function TransparentBlogCard({ image, title, description, action, popular }) {
  const cardActionStyles = {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    "& .material-icons, .material-icons-round": {
      transform: "translateX(2px)",
      transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
    },
    "&:hover .material-icons, &:focus .material-icons, &:hover .material-icons-round, &:focus .material-icons-round":
      {
        transform: "translateX(6px)",
      },
  };

  const renderActionLink = (type, route, label, color) => {
    if (type === "internal") {
      return (
        <MKTypography
          component={Link}
          to={route}
          variant="body2"
          fontWeight="regular"
          color={color}
          textTransform="capitalize"
          sx={cardActionStyles}
        >
          {label}
          <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
        </MKTypography>
      );
    }

    if (type === "external") {
      return (
        <MKTypography
          component={MuiLink}
          href={route}
          target="_blank"
          rel="noreferrer"
          variant="body2"
          fontWeight="regular"
          color={color}
          textTransform="capitalize"
          sx={cardActionStyles}
        >
          {label}
          <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
        </MKTypography>
      );
    }

    return null;
  };

  const renderImage = () => (
    <MKBox position="relative" borderRadius="lg">
      <MKBox
        component="img"
        src={image}
        alt={title}
        borderRadius="lg"
        shadow="md"
        width="100%"
        position="relative"
        zIndex={1}
      />
      <MKBox
        borderRadius="lg"
        shadow="md"
        width="100%"
        height="100%"
        position="absolute"
        left={0}
        top={0}
        sx={{
          backgroundImage: `url(${image})`,
          transform: "scale(0.94)",
          filter: "blur(12px)",
          backgroundSize: "cover",
        }}
      />
    </MKBox>
  );

  const renderTitleLink = () => {
    if (action?.route && action?.type === "internal") {
      return (
        <Link to={action.route} style={{ textDecoration: "none" }}>
          <MKTypography variant="h5" gutterBottom>
            {title}
          </MKTypography>
        </Link>
      );
    }

    if (action?.route && action?.type === "external") {
      return (
        <MuiLink
          href={action.route}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <MKTypography variant="h5" gutterBottom>
            {title}
          </MKTypography>
        </MuiLink>
      );
    }

    return (
      <MKTypography variant="h5" gutterBottom>
        {title}
      </MKTypography>
    );
  };

  return (
    <Card
      sx={{
        background: "transparent",
        boxShadow: "none",
        overflow: "visible",
        height: "100%",
      }}
    >
      <MKBox display="flex" flexDirection="column" height="100%">
        {image &&
          (action?.route ? (
            action.type === "internal" ? (
              <Link to={action.route}>{renderImage()}</Link>
            ) : (
              <MuiLink href={action.route} target="_blank" rel="noreferrer">
                {renderImage()}
              </MuiLink>
            )
          ) : (
            renderImage()
          ))}

        {title && (
          <MKBox
            pt={2}
            borderBottom="1px solid lightgrey"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            {renderTitleLink()}
            {popular && (
              <MKBadge
                color="primary"
                badgeContent="Popular"
                container
                size="xs"
                sx={{ ml: 2, p: 0 }}
              />
            )}
          </MKBox>
        )}

        {description &&
          (action?.label ? (
            <MKBox pt={2} pb={3} height="100%">
              <MKTypography variant="body2" component="p" color="text">
                {description}
              </MKTypography>
            </MKBox>
          ) : (
            <MKBox pt={2} pb={3} height="100%" borderBottom="1px solid lightgrey">
              <MKTypography variant="body2" component="p" color="text">
                {description}
              </MKTypography>
            </MKBox>
          ))}

        {action?.route && action?.type && action?.label && (
          <MKBox
            pt={0}
            pb={1}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            borderBottom="1px solid lightgrey"
          >
            {renderActionLink(action.type, action.route, action.label, action.color)}
          </MKBox>
        )}
      </MKBox>
    </Card>
  );
}

// Typechecking props for the TransparentBlogCard
TransparentBlogCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]),
    route: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.oneOf([
      "inherit",
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "light",
      "dark",
      "text",
    ]),
  }),
  popular: PropTypes.bool,
};

export default TransparentBlogCard;

// /* eslint-disable no-unused-vars */
// // react-router components
// import { Link } from "react-router-dom";

// // prop-types is a library for typechecking of props
// import PropTypes from "prop-types";

// // @mui material components
// import Card from "@mui/material/Card";
// import Icon from "@mui/material/Icon";
// import MuiLink from "@mui/material/Link";

// // Material Kit 2 React components
// import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";
// import MKBadge from "components/MKBadge";

// function TransparentBlogCard({ image, title, description, action, popular }) {
//   const cardActionStyles = {
//     display: "flex",
//     alignItems: "center",
//     width: "max-content",

//     "& .material-icons, .material-icons-round,": {
//       transform: `translateX(2px)`,
//       transition: "transform 0.2s cubic-bezier(0.34,1.61,0.7,1.3)",
//     },

//     "&:hover .material-icons, &:focus .material-icons, &:hover .material-icons-round, &:focus .material-icons-round":
//       {
//         transform: `translateX(6px)`,
//       },
//   };

//   const imageTemplate = (
//     <MKBox position="relative" borderRadius="lg">
//       <MKBox
//         component="img"
//         src={image}
//         alt={title}
//         borderRadius="lg"
//         shadow="md"
//         width="100%"
//         position="relative"
//         zIndex={1}
//       />
//       <MKBox
//         borderRadius="lg"
//         shadow="md"
//         width="100%"
//         height="100%"
//         position="absolute"
//         left={0}
//         top={0}
//         sx={{
//           backgroundImage: `url(${image})`,
//           transform: "scale(0.94)",
//           filter: "blur(12px)",
//           backgroundSize: "cover",
//         }}
//       />
//     </MKBox>
//   );

//   return (
//     <Card
//       sx={{
//         background: "transparent",
//         boxShadow: "none",
//         overflow: "visible",
//         height: "100%",
//       }}
//     >
//       <MKBox display="flex" flexDirection="column" height="100%">
//         {action && action.route && action.type === "internal" ? (
//           <Link to={action.route}>{imageTemplate}</Link>
//         ) : action && action.route && action.type === "external" ? (
//           <MuiLink href={action.route} target="_blank" rel="noreferrer">
//             {imageTemplate}
//           </MuiLink>
//         ) : (
//           imageTemplate
//         )}
//         <MKBox
//           pt={2}
//           borderBottom="1px solid lightgrey"
//           display="flex"
//           flexDirection="row"
//           alignItems="center"
//           justifyContent="space-between"
//         >
//           <MKBox display="flex" sx={{ textAlign: "justify", wordbreak: "break-all" }}>
//             {action && action.route && action.type === "internal" ? (
//               <Link to={action.route} sx={cardActionStyles}>
//                 <MKTypography
//                   variant="h5"
//                   gutterBottom
//                   // sx={{ textAlign: "justify", wordbreak: "break-all" }}
//                 >
//                   {title}
//                 </MKTypography>
//               </Link>
//             ) : action && action.route && action.type === "external" ? (
//               <MuiLink href={action.route} target="_blank" rel="noreferrer" sx={cardActionStyles}>
//                 <MKTypography
//                   variant="h5"
//                   gutterBottom
//                   // sx={{ textAlign: "justify", wordbreak: "break-all" }}
//                 >
//                   {title}
//                 </MKTypography>
//               </MuiLink>
//             ) : (
//               title
//             )}
//           </MKBox>
//           {popular && (
//             <MKBadge
//               // variant="contained"
//               color="primary"
//               badgeContent="Popular"
//               container
//               size="xs"
//               sx={{ ml: 2, p: 0 }}
//             />
//           )}
//         </MKBox>
//         {description && (
//           <MKBox pt={2} pb={3} height="100%">
//             <MKTypography variant="body2" component="p" color="text">
//               {description}
//             </MKTypography>
//           </MKBox>
//         )}

//         {action && action.route && action.type && action.label ? (
//           <MKBox
//             pt={0}
//             pb={1}
//             // pr={2}
//             display="flex"
//             alignItems="center"
//             justifyContent="flex-end"
//             borderBottom="1px solid lightgrey"
//           >
//             {action.type === "internal" ? (
//               <MKTypography
//                 component={Link}
//                 to={action.route}
//                 variant="body2"
//                 fontWeight="regular"
//                 color={action.color}
//                 textTransform="capitalize"
//                 sx={cardActionStyles}
//               >
//                 {action.label}
//                 <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
//               </MKTypography>
//             ) : action.type === "external" ? (
//               <MKTypography
//                 component={MuiLink}
//                 href={action.route}
//                 target="_blank"
//                 rel="noreferrer"
//                 variant="body2"
//                 fontWeight="regular"
//                 color={action.color}
//                 textTransform="capitalize"
//                 sx={cardActionStyles}
//               >
//                 {action.label}
//                 <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
//               </MKTypography>
//             ) : (
//               action.label
//             )}
//           </MKBox>
//         ) : null}
//       </MKBox>

//       {/* <MKBox pt={2} pb={3}>
//         {action.type === "internal" ? (
//           <Link to={action.route} sx={cardActionStyles}>
//             <MKTypography variant="h5" gutterBottom>
//               {title}
//             </MKTypography>
//           </Link>
//         ) : (
//           <MuiLink href={action.route} target="_blank" rel="noreferrer" sx={cardActionStyles}>
//             <MKTypography variant="h5" gutterBottom>
//               {title}
//             </MKTypography>
//           </MuiLink>
//         )}
//         <MKTypography variant="body2" component="p" color="text" mb={3}>
//           {description}
//         </MKTypography>
//         {action.type === "internal" ? (
//           <MKTypography
//             component={Link}
//             to={action.route}
//             variant="body2"
//             fontWeight="regular"
//             color={action.color}
//             textTransform="capitalize"
//             sx={cardActionStyles}
//           >
//             {action.label}
//             <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
//           </MKTypography>
//         ) : (
//           <MKTypography
//             component={MuiLink}
//             href={action.route}
//             target="_blank"
//             rel="noreferrer"
//             variant="body2"
//             fontWeight="regular"
//             color={action.color}
//             textTransform="capitalize"
//             sx={cardActionStyles}
//           >
//             {action.label}
//             <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
//           </MKTypography>
//         )}
//       </MKBox> */}
//     </Card>
//   );
// }

// // Typechecking props for the TransparentBlogCard
// TransparentBlogCard.propTypes = {
//   image: PropTypes.string.isRequired,
//   title: PropTypes.string,
//   description: PropTypes.string,
//   action: PropTypes.shape({
//     type: PropTypes.oneOf(["external", "internal"]),
//     route: PropTypes.string,
//     label: PropTypes.string,
//     color: PropTypes.oneOf([
//       "inherit",
//       "primary",
//       "secondary",
//       "info",
//       "success",
//       "warning",
//       "error",
//       "light",
//       "dark",
//       "text",
//     ]),
//   }),
//   popular: PropTypes.bool,
// };

// export default TransparentBlogCard;
